import './polyfills'

import Vue from 'vue'
import { mapGetters } from 'vuex'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store/store'
import { initialiseBuefy } from '@/config/setup/buefy.setup'
import { initialiseValidations } from '@/config/setup/validations.setup'
import { initialiseStore } from '@/config/setup/store.setup'
import { setupTracking } from '@/config/setup/tracking.setup'
import { initialiseVueMeta } from '@/config/setup/meta.setup'
import { i18n, loadCurrentTranslation } from '@/config/setup/i18n.setup'
import { initAmplify } from '@/config/setup/amplify.setup'
import { initAxios } from '@/config/setup/axios.setup'
import { insertManifest } from '@ui/shared-utils/src/index'

Vue.config.productionTip = false

export const initialiseApp = async () => {
  insertManifest()
  // load validations
  initialiseValidations()
  // load buefy components
  initialiseBuefy()
  // set default values to store
  await initialiseStore()
  // load vue meta
  initialiseVueMeta()
  // initialise axios
  initAxios()
  // initialise segment
  setupTracking(store.getters['site/segmentKey'], store.getters['site/oneTrustKey'], store.getters['site/useOneTrust'])
  // initialise translations
  await loadCurrentTranslation(store.getters['site/language'])
  // initialise Amplify
  initAmplify()
  // Load app
  return new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
    computed: {
      ...mapGetters({
        pseudoLocale: 'site/language',
        actualLocale: 'site/actualLocale'
      })

    },
    watch: {
      pseudoLocale: {
        immediate: true,
        handler: (pseudoLocale) => document.getElementsByTagName('html')[0].setAttribute('data-pseudo-locale', pseudoLocale)
      },
      actualLocale: {
        immediate: true,
        handler: (actualLocale) => document.getElementsByTagName('html')[0].setAttribute('lang', actualLocale.replace('_', '-'))
      }
    }
  }).$mount('#app')
}

initialiseApp()
